<template>
  <BaseCard
    title="Mağaza Tahsilat Durumu"
    customCardWrapperClass="custom-card-wrapper"
  >
    <template #bottom>
      <p class="info-text">
        Kira tutarı ₺ olarak girilen mağazaların gelirleri, toplam kira
        tahsilatları hesaplanırken güncel $ kuru olan
        <span id="currency-rate"></span> üzerinden hesaplanarak toplam $
        tahsilatına eklenmiştir. "Kalan (ayrılan kiracı)", mağazadan veya
        depodan ayrılmış kiracılardan henüz tahsil edilmemiş tutarı gösterir.
      </p>
      <BaseButtonGroup
        v-model="selectedButtonFilter"
        class="weeks-filter-buttons"
        :buttons="buttonOptions"
        variant="neutral"
        selectedVariant="secondary"
        bordered
        rounded
        @click="handleFilter"
      />
    </template>
    <template #card-0>
      <BaseChart
        v-if="dashboardStore.propertyRentCollectionChart"
        id="call-pie-chart"
        :data="dashboardStore.propertyRentCollectionChart"
        :options="rentOptions"
        type="bar"
        :style="{ height: '300px' }"
      />
    </template>
    <template #card-1>
      <BaseChart
        v-if="dashboardStore.propertySubscriptionCollectionChart"
        id="call-pie-chart"
        :data="dashboardStore.propertySubscriptionCollectionChart"
        :options="subscriptionOptions"
        type="bar"
        :style="{ height: '300px' }"
      />
    </template>
  </BaseCard>
  <BaseCard
    title="Depo Tahsilat Durumu"
    customCardWrapperClass="custom-card-wrapper"
  >
    <template #card-2>
      <BaseChart
        v-if="dashboardStore.storeRentCollectionChart"
        id="call-pie-chart"
        :data="dashboardStore.storeRentCollectionChart"
        :options="rentOptions"
        type="bar"
        :style="{ height: '300px' }"
      />
    </template>
  </BaseCard>
</template>

<script setup lang="ts">
import { BaseCard, BaseChart, BaseButtonGroup } from "@/components/Base";
import type { IButtonGroupOption } from "@/types/general";
import { ref } from "vue";
import type { ChartOptions } from "chart.js";
import { onBeforeMount, onBeforeUnmount } from "vue";
import { useDashboardStore } from "@/stores/modules/dashboard.store";

const dashboardStore = useDashboardStore();

const selectedButtonFilter = ref(new Date().getFullYear());
const buttonOptions = ref<IButtonGroupOption[]>([
  { key: 2024, text: "2024", value: 2024 },
  { key: 2025, text: "2025", value: 2025 },
  { key: 2026, text: "2026", value: 2026 },
  { key: 2027, text: "2027", value: 2027 },
]);

const rentOptions: ChartOptions<"bar"> = {
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: "Kira Tahsilatları",
      font: {
        size: 18,
      },
      padding: {
        top: 10,
        bottom: 10,
      },
      align: "center",
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      ticks: {
        callback: function (value) {
          return value + " $";
        },
      },
    },
  },
};

const subscriptionOptions: ChartOptions<"bar"> = {
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: "Aidat Tahsilatları",
      font: {
        size: 18,
      },
      padding: {
        top: 10,
        bottom: 10,
      },
      align: "center",
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      ticks: {
        callback: function (value) {
          return value + " ₺";
        },
      },
    },
  },
};

async function handleFilter() {
  await dashboardStore.getCollectionStatus(selectedButtonFilter.value);
  const currencyRateEl = document.getElementById("currency-rate");
  if (currencyRateEl) currencyRateEl.innerText = dashboardStore.currencyRate;
}

onBeforeMount(async () => {
  await dashboardStore.getCollectionStatus(selectedButtonFilter.value);
  const currencyRateEl = document.getElementById("currency-rate");
  if (currencyRateEl) currencyRateEl.innerText = dashboardStore.currencyRate;
});
onBeforeUnmount(() => {
  dashboardStore.$reset();
});
</script>

<style scoped lang="scss">
.weeks-filter-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}

.info-text {
  font-size: 14px;
  color: #6c757d; /* Bootstrap text-secondary color */
  margin-bottom: 10px;
}
</style>
